// extracted by mini-css-extract-plugin
export var billingAddress = "_r5-f";
export var contactInfo = "_r5-c";
export var customerInfoContainer = "_r5-b";
export var customerInfoRow = "_r5-9";
export var customerInfoSection = "_r5-a";
export var fullWidthDividerMobile = "_r5-g";
export var imageContainer = "_r5-1";
export var paymentMethod = "_r5-d";
export var priceText = "_r5-6";
export var priceTextMobile = "_r5-7";
export var product = "_r5-0";
export var productImage = "_r5-2";
export var productInfo = "_r5-4";
export var productTitle = "_r5-8";
export var quantityBadge = "_r5-3";
export var quantityText = "_r5-5";
export var shippingAddress = "_r5-e";